import {
  VehicleTypeEditFormValues,
  VehicleTypeSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CONTACT EDIT
---------------------------------------------------------------------------------------------*/

export const initialVehicleTypeEditForm: VehicleTypeEditFormValues = {
  name: null,
   image: null,
   availability: "",
   basePrice: null,
   bodyCode: null,
   co2: null,
   cylinderCapacity: null,
   drivenWheels: null,
   engine: null,
   fuelType: null,
   liters: null,
   manufacturerCode: "",
   maximumPowerHp: null,
   maximumPowerKw: null,
   numberOfDoors: null,
   price: null,
   roofType: null,
   seats: null,
   secondaryFuelType: null,
   transmission: null,
   trimLevel: null,
   vehicleTypeCode: null,
   wheelbaseType: null,
};

/*-------------------------------------------------------------------------------------------
  CONTACT SEARCH
---------------------------------------------------------------------------------------------*/
export const initialVehicleTypeSearchForm: VehicleTypeSearchFormValues = {
  search: "",
  vehicleManufacturerId: "",
  vehicleModelId: null,
};

